import { render, staticRenderFns } from "./SectionSlogan.vue?vue&type=template&id=4a2dd5c4&scoped=true&"
import script from "./SectionSlogan.vue?vue&type=script&lang=js&"
export * from "./SectionSlogan.vue?vue&type=script&lang=js&"
import style0 from "./SectionSlogan.vue?vue&type=style&index=0&id=4a2dd5c4&lang=scss&scoped=true&"
import style1 from "./SectionSlogan.vue?vue&type=style&index=1&id=4a2dd5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2dd5c4",
  null
  
)

export default component.exports